import { Typography, Divider as AntdDivider } from 'antd';
import styled from 'styled-components';
import { Modal as OzoneModal } from 'components/atoms/modal';

const { Text } = Typography;

export const PlaceholderText = styled(Text).attrs({ type: 'secondary' })`
  color: var(--gray-50);
`;

export const Divider = styled(AntdDivider)`
  margin: 0;
`;

export const Modal = styled(OzoneModal).attrs({ maskClosable: false })`
  min-width: 880px;
`;
